// extracted by mini-css-extract-plugin
module.exports = {"universeAddBtn":"styles__universeAddBtn--189fm","deleteBtn":"styles__deleteBtn--3Gt0J"};